<div
  *ngIf="!labelTemplate"
  [ngClass]="getLabelClass()">
  {{label | translate}}
</div>
<ng-template *ngTemplateOutlet="labelTemplate"></ng-template>